export default "/images/Logo.svg?6a8745da5f34430803858422ecce4bb3";